import { type VariantProps, cva } from 'class-variance-authority';
import { type PropsWithChildren } from 'react';

import { type PropsWithClassName } from '~/utils/props-with-classname';

const bgVariants = cva(
  'text-primary-foreground relative before:absolute before:left-0 before:top-0 before:h-full before:w-full before:bg-cover before:bg-no-repeat before:brightness-[0.3] before:content-[""]',
  {
    variants: {
      variant: {
        bg1: 'before:bg-[url(/img/landing-header-bg-1.jpg)] before:bg-[center_15%]',
        bg2: 'before:bg-[url(/img/landing-header-bg-2.jpg)] before:bg-[center_35%]',
        bg3: 'before:bg-[url(/img/landing-header-bg-3.jpg)] before:bg-[center_30%]',
      },
    },
  },
);

type BgVariant = VariantProps<typeof bgVariants>['variant'];

const randomVariant = (arr: BgVariant[]) => arr[Math.floor(Math.random() * arr.length)];

type RandomBackgroundProps = PropsWithChildren<PropsWithClassName<unknown>>;

export default function RandomBackground({ children, className }: RandomBackgroundProps) {
  const bgVariant = randomVariant(['bg1', 'bg2', 'bg3']);

  return <div className={bgVariants({ variant: bgVariant, className })}>{children}</div>;
}
